import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import useModal from 'hooks/useModal'
import { useMemo } from 'react'
import Payment, { PaymentProps } from '..'

export const usePresentPaymentModal = () => {
  const [onPressentModalPaymnet, onDismiss] = useModal(Payment)
  const { isMobile } = useMatchBreakpoints()

  return useMemo(() => {
    return [(data?: PaymentProps) => onPressentModalPaymnet(data, !isMobile), onDismiss]
  }, [onPressentModalPaymnet, isMobile])
}
